import { Component, inject, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

import { TranslateModule } from '@ngx-translate/core';
import { AlertService } from './alert.service';

@Component({
  selector: 'alert',
  imports: [CommonModule, MatButton, MatIcon, TranslateModule],
  templateUrl: './alert.component.html',
  styleUrl: './alert.component.scss',
})
export class AlertComponent {
  alertService = inject(AlertService);
  options = computed(this.alertService.alertOptions);

  clickAction() {
    const action = this.options().action;
    if (action) {
      action();
    }
    this.alertService.closeAlert();
  }
}
